import type { ReactNode } from "react";

import { cn } from "../lib/utils";

/**
 * The workspace page title, as a breadcrumb. Following T3Code: a page whose chrome condenses on
 * scroll swaps the plain title for the live scope without changing the shape of the line.
 */
export function WorkspaceBreadcrumb({
  ariaLabel,
  children,
  className,
}: {
  readonly ariaLabel: string;
  readonly children: ReactNode;
  readonly className?: string;
}) {
  return (
    <nav aria-label={ariaLabel} className={cn("min-w-0", className)}>
      {/* Keep the flexible container draggable in Electron. Interactive descendants are
          excluded by the shared `.drag-region` rules. */}
      <ol className="m-0 flex min-w-0 list-none items-center gap-2 p-0 text-sm sm:gap-3">
        {children}
      </ol>
    </nav>
  );
}

export function WorkspaceBreadcrumbItem({
  children,
  className,
  current = false,
}: {
  readonly children: ReactNode;
  readonly className?: string;
  readonly current?: boolean;
}) {
  return (
    <li
      aria-current={current ? "page" : undefined}
      className={cn(
        "flex min-w-0 items-center font-medium",
        current ? "text-foreground" : "shrink-0 text-muted-foreground",
        className,
      )}
    >
      {children}
    </li>
  );
}

export function WorkspaceBreadcrumbSeparator({ className }: { readonly className?: string }) {
  return (
    <li
      aria-hidden="true"
      className={cn("flex shrink-0 items-center text-muted-foreground/60", className)}
    >
      /
    </li>
  );
}
